import { Navigate, useParams } from 'react-router-dom';

/**
 * 旧链接 /dc/experts/:id 重定向到列表并带上 detail 查询参数，由 ExpertOverview 打开详情抽屉。
 */
export default function ExpertLegacyRedirect() {
    const { id } = useParams();
    return <Navigate to={`/dc/experts?detail=${encodeURIComponent(id)}`} replace />;
}
